<template>
	<section class="page page-place-gallery">
		<ChalkyUiPageHero
			class="collapsed"
			description="Meet the locals that play out of here."
			v-bind:imageUrl="imageUrl"
			v-bind:title="venueModel.getName()"
			v-if="venueModel.uniqueKey"
			v-on:click.native="Handle_OnClickHero"
		/>

		<ChalkyUtilityTabGroup v-bind:tabs="['Community']" v-if="venueModel.uniqueKey" v-slot="{ activeTab }">
			<div v-show="activeTab === 'community'">
				<ViewVenueCommunityGallery
					v-bind:key="venueModel.taggedMedia.uniqueKey"
					v-bind:venueModel="venueModel"
					v-on:select="Handle_OnSelectMediaGalleryItem"
				/>
			</div>
		</ChalkyUtilityTabGroup>
	</section>
</template>

<script lang="ts">
	import * as Mixins from '@/Mixins';
	import ChalkySticks from '@chalkysticks/sdk';
	import PageBase from '@/Core/Page.vue';
	import { Component, Prop } from 'vue-property-decorator';
	import { beforeDestroy, mounted } from '@/Utility/Decorators';

	/**
	 * Optional independent gallery page for a place.
	 *
	 * We are leaning towards an overlay/modal to display galleries, but
	 * this is a good demonstration of reusability in case we need it.
	 *
	 * @author Matt Kenefick <matt@chalkysticks.com>
	 * @package Page
	 * @project ChalkySticks App
	 */
	@Component
	export default class PagePlaceGallery extends PageBase {
		/**
		 * URL of the hero image
		 *
		 * @type string
		 */
		protected imageUrl: string = '';

		/**
		 * @type ChalkySticks.Model.Venue
		 */
		protected venueModel: ChalkySticks.Model.Venue = ChalkySticks.Factory.Venue.model();

		/**
		 * @return Promise<void>
		 */
		@mounted
		protected async setup(): Promise<void> {
			this.venueModel.set({
				id: this.$route.params.id,
			});

			// Fetch venue if not
			await this.venueModel.fetch();

			// Set image
			this.imageUrl = this.venueModel.media.primary?.getUrlMedium() || '';
		}

		// region: Event Handlers
		// ---------------------------------------------------------------------------

		/**
		 * @param ChalkySticks.Model.Media mediaModel
		 * @param number index
		 * @return Promise<void>
		 */
		protected async Handle_OnSelectMediaGalleryItem(
			mediaModel: ChalkySticks.Model.Media,
			index: number,
		): Promise<void> {
			this.$router.push({
				name: 'PagePlaceGalleryItem',
				params: {
					id: this.venueModel.id,
					mediaId: mediaModel.id,
				},
			});
		}

		// endregion: Event Handlers
	}
</script>

<style lang="scss">
	.page-place-gallery {
		.ui-pagehero figure::before {
			background: linear-gradient(34deg, rgba(165, 63, 66, 1) 18%, rgba(165, 63, 66, 0) 67%);
			content: ' ';
			height: 100%;
			pointer-events: none;
			position: absolute;
			opacity: 0.75;
			width: 100%;
		}

		.utility-gallery.grid .gallery-item {
			aspect-ratio: 1 / 1;
		}

		.utility-pagination {
			flex: 0 0 auto !important;
			justify-content: center;
		}
	}
</style>
